export const getVisiblePeriods = (periods, expandedPeriods) => {
    if (periods == null || expandedPeriods == null) return [];

    const flags =
        typeof expandedPeriods === 'string'
            ? expandedPeriods.split('')
            : Array.isArray(expandedPeriods)
            ? expandedPeriods
            : [];

    const result = [];
    flags.forEach((isPeriod, index) => {
        if (isPeriod && periods[index] != null) result.push(periods[index]);
    });
    return result;
};